import React from 'react'

function ConfirmActionModal(props) {
    const { id, headerText, bodyText, confirmText, cancelText, onClick } = props;
    return (
        <div className="modal fade" id={id} tabIndex="-1" role="dialog" aria-labelledby={id} aria-hidden="true">
            <div className="modal-dialog modal-sm modal-dialog-centered" role="document">
                <div className="modal-content">
                    {headerText &&
                        <div className="modal-header">
                            <h2 className="h6 modal-title">{headerText}</h2>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                    }
                    {bodyText &&
                        <div className="modal-body" style={{ whiteSpace: "normal" }}>{bodyText}</div>
                    }
                    <div className="modal-footer">
                        <button type="button" className="btn btn-primary" data-bs-dismiss="modal" onClick={onClick}>{confirmText}</button>
                        <button type="button" className="btn btn-link text-gray ms-auto" data-bs-dismiss="modal">{cancelText}</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ConfirmActionModal;
